import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations.js'
import actions from './actions.js'

Vue.use(Vuex);

const state = {
	userInfo: null
};

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters: {
		getUserInfo(state) {
			return state.userInfo;
		}
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js